import {fetchDeliveryInstruction} from '@web/actions/deliveryInfo'
import {APIStatus} from '@web/core/constants'
import makeSlice from '@web/slices/common/sliceMaker'

const commonSlice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(fetchDeliveryInstruction.pending, (state) => {
                state.scene = APIStatus.PENDING
            })
            .addCase(fetchDeliveryInstruction.fulfilled, (state) => {
                state.scene = APIStatus.RESOLVED
            })
            .addCase(fetchDeliveryInstruction.rejected, (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default commonSlice.reducer
export const actions = commonSlice.actions
